import _ from 'lodash'

export const czSorter = direction => (a, b) => {
    let comp = 0
    if (a === undefined) {
        comp = 1
    } else if (b === undefined) {
        comp = -1
    } else if (_.isBoolean(a)) {
        comp = a > b ? -1 : 1
    } else if (_.isNumber(a)) {
        comp = a === b ? 0 : a > b ? 1 : -1
    } else {
        if (a === null || a === undefined || a === '') return 1
        comp = a.localeCompare(b, 'cs')
    }
    return direction === 'asc' ? comp : comp * -1
}

export default {
    czSorter,
}
